// extracted by mini-css-extract-plugin
export default {"root":"DZVuP","title":"_0pUT","description":"Q0_PM","confirm":"olW7q","actions":"k4gtJ","button":"HW2uc"};